/* import __COLOCATED_TEMPLATE__ from './vat-details-component.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class VatDetailsComponent extends Component {
  @service customerService;
  @service appService;
  @tracked companyAddressIsOpen = false;
  @tracked shouldFocusOnVatField = false;

  get vatNumber() {
    return this.customerService.customer.vatNumber;
  }

  get app() {
    return this.appService.app;
  }

  get taxKeys() {
    return {
      number: 'billing.billing-settings.payment-info.tax-number',
      noNumber: 'billing.billing-settings.payment-info.no-tax-number',
      editNumber: 'billing.billing-settings.payment-info.edit-tax-number',
      addNumber: 'billing.billing-settings.payment-info.add-tax-number',
    };
  }
}
